export default function RadioInput({onChange,value,options,name,onSelect,selected}){
    
    if(!options || !Array.isArray(options) || options.length < 1) {
        return;
    }

    const handleClickOption = (option) => {
        onSelect(option?.value);
        if(option?.type === 'free-text') {
            onChange('');
        } else {
            onChange(option?.value);
        }
    }

    const handleChangeInput = (value) => {
        onChange(value);
    }

    return (
        <div className="pb-[24px]">
        {options.map((option,index)=><div key={`${name}-${index}`} className={`text-grey-600 text-[14px] font-[400] h-[24px] leading-[24px] w-[100%] relative cursor-pointer select-none mt-[25px]`} onClick={()=> handleClickOption(option)}>
            <span className={`w-[24px] h-[24px] inline-block me-[8px] align-middle`} style={{background: `url('/assets/images/${option?.value === selected ? 'radio-check.svg' : 'radio-uncheck.svg'}')`}}></span>
            <label className="mb-[1px] inline-block cursor-pointer align-middle text-grey-600 text-[14px] font-[400]">{option.label}</label>
        </div>)}
        {selected === 'other' && <>
            <div className="ps-[32px] pt-[8px]">
                <textarea placeholder="اكتب السبب الذي تريد" className="border-[1px] border-grey-300 rounded-[8px] p-[12px] min-h-[100px] w-full outline-none text-[16px] font-[500]" onChange={(e)=> handleChangeInput(e.target.value)} defaultValue={value}></textarea>   
            </div>
        </>}
        </div>
    )
}